// eslint-disable-next-line
export const isStringArray = (value: any): value is string[] => {
    if (value instanceof Array) {
        return value.every((item) => typeof item === "string");
    }

    return false;
};
